import React, { useState, useEffect } from "react";
import SliderPrincipalHome from "./modules/SliderPrincipalHome";
import ApresentacaoWaldir from "./modules/ApresentacaoWaldir";
import TradicaoFamilia from "./modules/TradicaoFamilia";
import ReformaDePianos from "./modules/ReformaDePianos";
import Descupinizacao from "./modules/Descupinizacao";
import PianoCards from "./modules/PianoCards";
import Depoimentos from "./modules/Depoimentos";
import OrcamentoPiano from "./modules/OrcamentoPiano";
import PianosVenda from "./modules/PianosVenda";
import SeoHead from "../../components/Menu/components/SeoHead";


const Home = () => {

  const homeSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": "https://pianoswaldir.com.br/#website",
      "url": "https://pianoswaldir.com.br/",
      "name": "Waldir Pianos",
      "description": "Especialistas em reforma, venda, aluguel, manutenção e descupinização de pianos. Tradição e qualidade há décadas.",
      "publisher": {
        "@id": "https://pianoswaldir.com.br/#organization"
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://pianoswaldir.com.br/?s={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      },
      "inLanguage": "pt-BR"
    },
    {
      "@type": "LocalBusiness",
      "@id": "https://pianoswaldir.com.br/#organization",
      "name": "Waldir Pianos",
      "url": "https://pianoswaldir.com.br/",
      "logo": "https://pianoswaldir.com.br/images/logo.jpg", 
      "image": "https://pianoswaldir.com.br/90_piano_brasil_vertical_acustico_541_4_a4be33b9a040bc56a48a9733bdc6450a.webp", 
      "telephone": "+55-11-2256-5987",
      "email": "mailto:comercial@pianoswaldir.com.br",
      "priceRange": "$$$", // Exemplo: indique o nível de preço, $, $$, $$$
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Rua Waldemar Martins, 695",
        "addressLocality": "São Paulo",
        "addressRegion": "SP",
        "postalCode": "02535-000",
        "addressCountry": "BR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": -23.504627, 
        "longitude": -46.666998 
      },
      "hasMap": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.0776735581177!2d-46.666998!3d-23.504627!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce5957d19a4e23%3A0x7d6a9a7a9a7a9a7a!2sWaldir%20Pianos!5e0!3m2!1spt-BR!2sbr!4v1678901234567!5m2!1spt-BR!2sbr", // URL do Google Maps (substitua pela sua)
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "08:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Saturday", "Sunday"],
          "description": "Agendado"
        }
      ],
      "knowsAbout": [
        { "@type": "Service", "name": "Reforma de Pianos" },
        { "@type": "Service", "name": "Venda de Pianos" },
        { "@type": "Service", "name": "Manutenção de Pianos" },
        { "@type": "Service", "name": "Aluguel de Pianos" },
        { "@type": "Service", "name": "Descupinização de Pianos" },
        { "@type": "Service", "name": "Afinação de Pianos" } 
      ],
      "sameAs": [
        "https://www.facebook.com/WaldirPianos", // Substitua pelas suas redes sociais
        "https://www.instagram.com/waldirpianos/"  // Substitua pelas suas redes sociais
       
      ]
    },
    {
      "@type": "WebPage",
      "@id": "https://pianoswaldir.com.br/#webpage",
      "url": "https://pianoswaldir.com.br/",
      "name": "Waldir Pianos | Reforma, Venda, Aluguel e Manutenção de Pianos",
      "description": "Descubra a Waldir Pianos: mais de 50 anos de tradição na reforma, venda, aluguel, manutenção e descupinização de pianos. Qualidade garantida e atendimento especializado para seu instrumento.",
      "isPartOf": {
        "@id": "https://pianoswaldir.com.br/#website"
      },
      "inLanguage": "pt-BR",
      "primaryImageOfPage": {
        "@type": "ImageObject",
        "url": "https://pianoswaldir.com.br/90_piano_brasil_vertical_acustico_541_4_a4be33b9a040bc56a48a9733bdc6450a.webp",
        "width": 1200, 
        "height": 675 
      }
    }
  ]
};

  

  return (
    <div className="container">

 <SeoHead
  title="Waldir Pianos | Especialistas em Reforma, Venda e Manutenção de Pianos em São Paulo"
  description="Mais de 50 anos de tradição! Waldir Pianos oferece reforma completa, venda, aluguel, afinação e descupinização de pianos. Qualidade, confiança e paixão pela música em SP."
  keywords="waldir pianos, reforma de piano, venda de piano, aluguel de piano, manutenção de piano, afinação de piano, descupinização de piano, piano de cauda, piano vertical, pianos usados, loja de pianos São Paulo"
  author="Waldir Pianos"
  image="/90_piano_brasil_vertical_acustico_541_4_a4be33b9a040bc56a48a9733bdc6450a.webp" 
  url="https://pianoswaldir.com.br/"
  canonicalUrl="https://pianoswaldir.com.br/"
  schemaMarkup={homeSchema}
/>
 

   

   
      <SliderPrincipalHome/>
      <ApresentacaoWaldir/>
      <TradicaoFamilia/>
      <PianosVenda/>
      <ReformaDePianos/>
      <Descupinizacao/>
      <PianoCards/>
      <Depoimentos/>
      <OrcamentoPiano/>
      
  
    </div>
  );
};

export default Home;
